module.exports = __webpack_public_path__ + "assets/img/Refund Policy.0bf4e38e.svg";